<div class="content-area">
  <div class="clr-row" id="search-row">
    <div class="clr-col-10 clr-col-md-8">
      <h1>Planșe de colorat biblice</h1>
    </div>
    <div class="clr-col-12 clr-col-sm-8 clr-col-md-6">
      <form clrForm id="search-form">
        <clr-input-container>
          <input clrInput placeholder="Caută colecții de planșe" name="name" [(ngModel)]="searchText"/>
        </clr-input-container>
      </form>
    </div>
    <div class="clr-col-12 clr-col-sm-4 mt-2 mt-md-0">
      <button class="orange-button mr-2 mb-2"
              type="submit"
              form="search-form"
              [disabled]="isLoading"
              (click)="search();"
      >
        Caută
      </button>
      <button class="orange-outline-button mb-2"
              [disabled]="isLoading"
              (click)="resetSearch();"
      >
        Resetează
      </button>
    </div>
  </div>
  <app-loading-component *ngIf="isLoading"></app-loading-component>
  <div class="clr-row" *ngIf="!isLoading">
    <div class="clr-col-10 clr-col-md-8" id="posts-wrapper">
      <div class="clr-row">
        <div class="clr-col-12 clr-col-sm-4" *ngFor="let post of posts">
          <app-coloring-thumbnail-post [postData]="post"></app-coloring-thumbnail-post>
        </div>
      </div>
      <div *ngIf="!posts || (posts && posts.length < 1)" class="text-center">
        Ne pare rău, se pare că nu avem încă conținut în această secțiune.
      </div>
    </div>
  </div>
  <app-pagination
      [page]="page"
      [pagesCount]="pagesCount"
      *ngIf="!isLoading"
      (pageChange)="onPageChange($event)"
  ></app-pagination>
</div>
